export const API_URL = 'https://api.juliesandlauglobal.com/v1/';
export const PATH_URL = 'https://cdn.juliesandlauglobal.com/';
export const API_LOCALHOST = 'https://juliesandlauglobal.com/';

// export const API_URL = "http://localhost:3004/v1/";
// export const API_URL = 'http://10.23.5.173:3004/v1/';
// export const PATH_URL = 'http:/localhost:3004/';
// export const API_LOCALHOST = 'http://localhost:3000/';
